import React, { useState } from "react";
import "./BrokerConnect.css";
import badge from "../../assets/images/badge.png";
import BrokerHeader from "../BrokerHeader/BrokerHeader";
import { useLocation, useNavigate } from "react-router-dom";

const BrokerConnect = () => {
  const [mobile, setMobile] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState("");
  const { state } = useLocation();
  const navigate = useNavigate();
  const broker = state?.broker;

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Only numbers
    if (value.length <= 10) {
      setMobile(value);
      setError("");
    }
  };

  const handleSubmit = () => {
    if (mobile.length !== 10) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }
    if (!accepted) {
      setError("Please accept the terms & conditions");
      return;
    }

    // Handle submission logic here
    const phoneNumber = `(${countryCode}) ${mobile.slice(0, 3)} ${mobile.slice(3, 6)} ${mobile.slice(6)}`;
    console.log("Submitting:", countryCode + mobile);

    // API call would go here, then navigate to OTP screen
    navigate(`/broker-integration/${broker?.name}/verify-otp`, {
      state: { broker, phoneNumber, mobile, countryCode },
    });
  };

  return (
    <div className="connect-wrapper">
      {/* Container with box shadow */}
      <div className="connect-container">
        {/* Top logos section */}
        <BrokerHeader />

        {/* Main Card */}
        <div className="connect-card">
          <h2 className="card-title">Connect Your Broker</h2>

          {/* Security Badge */}
          <div className="secure-badge">
            <img src={badge} alt="Secure Badge" />
            <span>Rest Assured, Your Data is Fully Encrypted</span>
          </div>

          {/* Input Section */}
          <div className="form-section">
            <label className="input-label">Enter Your Number</label>

            <div className="mobile-input-container">
              <select
                className="country-code-select"
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
              >
                <option value="+91">+91</option>
                <option value="+1">+1</option>
                <option value="+44">+44</option>
              </select>
              <div className="input-divider"></div>
              <input
                type="tel"
                className="mobile-input"
                placeholder="Enter Your Number"
                value={mobile}
                onChange={handleMobileChange}
                maxLength={10}
              />
            </div>

            {error && <p className="error-message">{error}</p>}
          </div>

          {/* Submit Button */}
          <button
            className={`submit-btn ${!mobile || !accepted ? "disabled" : ""}`}
            onClick={handleSubmit}
            disabled={!mobile || !accepted}
          >
            Submit
          </button>

          {/* Info Text */}
          <p className="info-text">
            Register with your WhatsApp number to get more details and stay
            informed.
          </p>

          {/* Terms Checkbox */}
          <label className="terms-label">
            <input
              type="checkbox"
              className="terms-checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
            />
            <span className="terms-text">
              I Accept the <span className="terms-link">terms & condition</span>
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default BrokerConnect;
